<template>
  <b-overlay :show="overlay" rounded="sm">
    <b-card
      v-if="!nocard"
      :title="title"
      :aria-hidden="show ? 'true' : null"
      :no-body="nobody"
      :class="{ 'card-transparent': transparent }"
    >
      <slot></slot>
    </b-card>
    <slot v-else></slot>
    <template v-slot:overlay>
      <div class="text-center">
        <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
        <p id="cancel-label">Chờ chút nhé...</p>
      </div>
    </template>
  </b-overlay>
</template>
<script>
export default {
  name: "block",
  props: {
    title: {},
    show: {},
    nocard: {
      default: false
    },
    nobody: {
      default: false
    },
    transparent: {
      default: false
    }
  },
  data() {
    return {
      overlay: false
    };
  },
  methods: {
    unBlock() {
      setTimeout(() => {
        this.overlay = false;
      }, 200);
    },
    block() {
      this.overlay = true;
    }
  },
  watch: {
    show: function() {
      this.overlay = this.show;
    }
  }
};
</script>
